import { render, staticRenderFns } from "./FanCoilOthers.vue?vue&type=template&id=2fd0d90b&scoped=true&"
import script from "./FanCoilOthers.vue?vue&type=script&lang=js&"
export * from "./FanCoilOthers.vue?vue&type=script&lang=js&"
import style0 from "./FanCoilOthers.vue?vue&type=style&index=0&id=2fd0d90b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd0d90b",
  null
  
)

export default component.exports